// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__33XmL","col":"styles_col__1MIC9"};